import {LitElement, svg, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';
import {
	selectSolarGenerators,
	selectSolarLumHeight1, selectSolarLumHeight2,
	selectSolarLuminarCountValue,
	selectSolarLumPosition1,
	selectSolarLumPosition2
} from '../../solarSelectors';

@customElement('svg-aeto')
export class SvgAeto extends connect(store)(LitElement) {

	static styles = css`
	  :host {
		display: flex;
		  height: 100%;
	  }

	  svg {
		height: 100%;
		width: auto;
		margin: auto;
	  }

	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.decisions = state.decisions.data;
		this.solar = state.solar.data;
		this.status = state.status;
		this.luminarCount = selectSolarLuminarCountValue(this.state);
		this.generators = selectSolarGenerators(this.state);
		this.pos1 = selectSolarLumPosition1(this.state);
		this.pos2 = selectSolarLumPosition2(this.state);
	}

	render() {
		const s = this.state;
		const svgPath = this.status.host + this.status.baseUrl + 'visuals/aeto.svg';
		return svg`
			<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="Aeto" width="1354" height="8305" viewBox="0 0 1354 8305" fill="none">

				<g id="Aeto-2" transform="translate(677,3896) translate(-677,-3896)">
					<use href="${svgPath}#Mast"></use>
					${when(this.generators >= 4, () => svg`
						<g id="Module4" transform="translate(677,910.5) translate(-677,-910.5)">
							${when(this.luminarCount >= 2 && this.pos2 === 4, () => svg`
								<g id="Left" transform="translate(677,910.5) translate(-677,-910.5)">
									<use href="${svgPath}#Module4_Left"></use>
								</g>
							`)}
							${when(this.pos1 === 4, () => svg`
								<g id="Right" transform="translate(677,910.5) translate(-677,-910.5)">
									<use href="${svgPath}#Module4_Right"></use>
								</g>
							`)}
							<g id="Panel" transform="translate(677,910.5) translate(-677,-910.5)">
								<use href="${svgPath}#Module4_Panel"></use>
							</g>
							<g id="Top" transform="translate(677,910.5) translate(-677,-910.5)">
								<use href="${svgPath}#Module4_Top"></use>
							</g>
						</g>
					`)}

					${when(this.generators >= 3, () => svg`
						<g id="Module3" fill="none" transform="translate(677,2731.5) translate(-677,-910.5)">
							${when(this.luminarCount >= 2 && this.pos2 === 3, () => svg`
								<g id="Left-2" transform="translate(677,910.5) translate(-677,-910.5)">
									<use href="${svgPath}#Module3_Left"></use>
								</g>
							`)}
							${when(this.pos1 === 3, () => svg`
								<g id="Right-2" transform="translate(677,910.5) translate(-677,-910.5)">
									<use href="${svgPath}#Module3_Right"></use>
								</g>
							`)}
							<g id="Panel-2" transform="translate(677,910.5) translate(-677,-910.5)">
								<use href="${svgPath}#Module3_Panel"></use>
							</g>
							${when(this.generators >= 4, () => svg`
								<g id="Top-2" transform="translate(677,910.5) translate(-677,-910.5)">
									<use href="${svgPath}#Module3_Top"></use>
								</g>
							`)}
						</g>
					`)}

					${when(this.generators >= 2, () => svg`
						<g id="Module2" fill="none" transform="translate(677,4552.5) translate(-677,-910.5)">
							${when(this.luminarCount >= 2 && this.pos2 === 2, () => svg`
								<g id="Left-3" transform="translate(677,910.5) translate(-677,-910.5)">
									<use href="${svgPath}#Module2_Left"></use>
								</g>
							`)}
							${when(this.pos1 === 2, () => svg`
								<g id="Right-3" transform="translate(677,910.5) translate(-677,-910.5)">
									<use href="${svgPath}#Module2_Right"></use>
								</g>
							`)}
							<g id="Panel-3" transform="translate(677,910.5) translate(-677,-910.5)">
								<use href="${svgPath}#Module2_Panel"></use>
							</g>
							${when(this.generators >= 3, () => svg`
								<g id="Top-3" transform="translate(677,910.5) translate(-677,-910.5)">
									<use href="${svgPath}#Module2_Top"></use>
								</g>
							`)}
						</g>
					`)}

					${when(this.generators >= 1, () => svg`
						<g id="Module1" fill="none" transform="translate(677,6373.5) translate(-677,-910.5)">
							${when(this.luminarCount >= 2 && this.pos2 === 1, () => svg`
								<g id="Left-4" transform="translate(677,910.5) translate(-677,-910.5)">
									<use href="${svgPath}#Module1_Left"></use>
								</g>
							`)}
							${when(this.pos1 === 1, () => svg`
								<g id="Right-4" transform="translate(677,910.5) translate(-677,-910.5)">
									<use href="${svgPath}#Module1_Right"></use>
								</g>
							`)}
							<g id="Panel-4" transform="translate(677,910.5) translate(-677,-910.5)">
								<use href="${svgPath}#Module1_Panel"></use>
							</g>
							${when(this.generators >= 2, () => svg`
								<g id="Top-4" transform="translate(677,910.5) translate(-677,-910.5)">
									<use href="${svgPath}#Module1_Top"></use>
								</g>
							`)}
						</g>
					`)}
				</g>
			</svg>
		`;
	}
}
